import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import LandingLab from './LandingLab';
import { resolvePostLoginRoute } from '../utils/resolvePostLoginRoute';

export default function HomeOrDashboard({ isDarkMode, toggleDarkMode }) {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const authToken = localStorage.getItem('authToken');
        const headers = authToken ? { Authorization: `Bearer ${authToken}` } : {};
        const me = await fetch(`${API_BASE_URL}/auth/me`, {
          credentials: 'include',
          headers,
        });
        if (!mounted) return;
        if (!me.ok) {
          setChecking(false);
          return;
        }
        const user = await me.json();
        if (!user) {
          setChecking(false);
          return;
        }

        const route = await resolvePostLoginRoute();
        if (!mounted) return;
        navigate(route);
      } catch (e) {
        // ignore and show home
      } finally {
        if (mounted) setChecking(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [navigate]);

  if (checking) return <div className="min-h-[60vh] flex items-center justify-center">Yükleniyor...</div>;

  return <LandingLab isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />;
}
